require('./ctxAppPanelToolbar.style.scss');
class ctxAppPanelToolbarController {
    constructor($scope) {

    }

}

ctxAppPanelToolbarController.$inject = ['$scope'];

const ctxAppPanelToolbarComponent = {
    controller: ctxAppPanelToolbarController,
    template: require('./ctxAppPanelToolbar.template.html'),
    scope: {},
    transclude: {
        toolbarSlot: '?appToolbar'
    },
    bindings: {
        appTitle: '@',
        buttons: '=?toolbarButtons',
        isBusy: '<?'
    }
};

module.exports = ctxAppPanelToolbarComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxAppPanelToolbar/ctxAppPanelToolbar.component.js